import { toast } from 'sonner';
import { invalidateLocationQueries } from '@/lib/locations/invalidate';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { normalizeJob } from '@/lib/normalizeJob';
import { bookingKeys, jobKeys, schedulerKeys } from '@/lib/queryKeys';
import type { Job, CreateJobDto } from '@/types/job';

/**
 * Creates a new job via the operations microservice.
 */
export const useCreateJob = createMutationHook<Job, CreateJobDto>({
  mutationFn: async (dto) =>
    normalizeJob(
      await apiPost<Record<string, unknown>, CreateJobDto>(
        operationsClient,
        jobEndpoints.create(),
        dto,
      ),
    ),
  onSuccess: (data, variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobKeys.lists() });
    if (variables.bookingId) {
      void queryClient.invalidateQueries({ queryKey: bookingKeys.detail(variables.bookingId) });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.bookings() });
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(data.id) });
      void queryClient.invalidateQueries({ queryKey: jobKeys.detail(data.id) });
    }
    // A typed service address is saved to the customer as a location on the
    // server, so this save may have created one. See `invalidateLocationQueries`.
    invalidateLocationQueries(queryClient, variables.contactId);
    toast.success('Job created');
  },
});
